(function () {
  'use strict';

  var API_BASE = 'https://creditsyard.com/api/common';
  var _initTimer = null;

  function getConfig() {
    return window.__MC26_CREDIT || null;
  }

  function scheduleInit() {
    clearTimeout(_initTimer);
    _initTimer = setTimeout(init, 400);
  }

  function init() {
    var config = getConfig();
    if (!config || !config.email) return;

    var widgets = document.querySelectorAll('[data-mc26-store-credit]');
    if (!widgets.length) return;

    widgets.forEach(function (ui) {
      var liquidBalance = parseFloat(ui.dataset.creditBalance) || 0;

      fetchBalance(config, function (balance) {
        var finalBalance = balance > 0 ? balance : liquidBalance;
        if (finalBalance > 0) {
          showCredit(ui, finalBalance);
        } else {
          ui.style.display = 'none';
        }
      });
    });
  }

  function fetchBalance(config, callback) {
    fetch(API_BASE + '/customers/get', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shop-Api-Key': config.apiKey
      },
      body: JSON.stringify({ customer_email: config.email })
    })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      })
      .then(function (data) {
        callback(parseFloat(data.balance) || 0);
      })
      .catch(function () {
        tryAppProxy(config, callback);
      });
  }

  function tryAppProxy(config, callback) {
    fetch('/apps/my-store-credit/api/common/customers/get', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customer_email: config.email })
    })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      })
      .then(function (data) {
        callback(parseFloat(data.balance) || 0);
      })
      .catch(function () {
        callback(0);
      });
  }

  function showCredit(ui, balance) {
    var descEl = ui.querySelector('[data-mc26-credit-desc]');
    if (descEl) descEl.textContent = formatMoney(balance) + ' available';
    ui.style.display = '';
  }

  function formatMoney(dollars) {
    var fmt = ((window.T4SThemeSP && T4SThemeSP.moneyFormat) || '${{amount}}').replace(/<[^>]*>/g, '');
    var amount = parseFloat(dollars).toFixed(2);
    var amountWithCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amountWithCommas)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(dollars).toString())
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
              .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(dollars).toString());
  }

  document.addEventListener('drawer:opened', scheduleInit);
  document.addEventListener('cart:updated', scheduleInit);

  if (typeof jQuery !== 'undefined') {
    jQuery(document).on('cart:updated', scheduleInit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
